import React, { useEffect, useState } from 'react';

import {
  Button,
  Grid,
  makeStyles,
  TextField,
  Typography,
} from '@material-ui/core';
import { updatePassword } from 'controllers/user/updatePassword';

const useStyles = makeStyles({
  container: {
    display: 'flex',
    justifyContent: 'center',
    zIndex: 10,
    paddingTop: '10px',
  },
  contentContainer: {
    display: 'flex',
    justifyContent: 'flex-start',
    flexDirection: 'column',
    maxWidth: '400px',
    paddingBottom: '24px',
  },
  title: {
    color: 'rgba(0, 0, 0, 0.87)',
    fontSize: '20px',
    fontWeight: 500,
    lineHeight: 1.3,
    letterSpacing: '0.26px',
    marginBottom: '10px',
  },
  subTitle: {
    color: '#a4a8ac',
    fontSize: '14px',
    fontWeight: 'normal',
    lineHeight: 1.33,
    marginBottom: '20px',
  },
  input: {
    marginBottom: '23px',
    '& .Mui-error': {
      color: '#49515a',

      '& .MuiOutlinedInput-notchedOutline': {
        borderColor: '#8d3b51',
      },
    },
    '& .MuiFormHelperText-root': {
      color: '#8d3b51',
      marginLeft: 0,
      marginTop: '10px',
    },
  },
  button: {
    height: '60px',
  },
  emptySpace: {
    padding: '16.5px 0',
  },
  emptySpace8: {
    padding: '4px 0',
  },
});

export const VerifyAndSetPassword = ({
  setIsLoading,
  resetId = '',
  setShowSuccessModal,
  setShowCodeExpiredModal,
}) => {
  const classes = useStyles();
  const [code, setCode] = useState('');
  const [pass, setPass] = useState('');
  const [confirmPass, setConfirmPass] = useState('');
  const [errors, setErrors] = useState({});

  useEffect(() => {
    return () => {
      setCode('');
      setPass('');
      setConfirmPass('');
      setErrors({});
    };
  }, []);

  const onChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;

    setErrors({});

    if (name === 'code') {
      setCode(value);
    } else if (name === 'pass') {
      setPass(value);
    } else if (name === 'confirmPass') {
      setConfirmPass(value);
    }
  };

  const onClickVerify = async () => {
    setIsLoading(true);

    const response = await updatePassword(code, pass, confirmPass, resetId);

    if (response.status) {
      setShowSuccessModal(true);
    } else if (response.type === 'codeExpired') {
      setShowCodeExpiredModal(true);
    } else if (response.type === 'code') {
      setErrors({ code: 'Code miss match! Check the code again.' });
    } else if (response.type === 'confirmPassword') {
      setErrors({ confirmPass: 'Password Doesn’t Match' });
    } else {
      // some other error
      setErrors({
        code: 'Some error occured. Please try again after sometime.',
      });
    }

    setIsLoading(false);
  };

  return (
    <Grid container classes={{ root: classes.container }}>
      <Grid item xs={12} classes={{ root: classes.contentContainer }}>
        <Typography classes={{ root: classes.title }}>
          Enter the Verification Code
        </Typography>
        <Typography classes={{ root: classes.subTitle }}>
          Verification code has been sent to your mail id.
        </Typography>
        <TextField
          label="Verification Code"
          placeholder="Enter code send to your mail"
          variant="outlined"
          classes={{ root: classes.input }}
          id="code-999"
          autoComplete="off"
          name="code"
          value={code}
          onChange={onChange}
          error={errors.code}
          helperText={errors.code}
        />
        <div className={classes.emptySpace} />
        <Typography classes={{ root: classes.title }}>Set Password</Typography>
        <div className={classes.emptySpace8} />
        <TextField
          label="New password"
          placeholder="Enter password"
          variant="outlined"
          classes={{ root: classes.input }}
          id="pass-99"
          autoComplete="off"
          name="pass"
          value={pass}
          onChange={onChange}
          error={errors.confirmPass}
        />
        <TextField
          label="Confirm password"
          placeholder="Re - Enter password"
          variant="outlined"
          type="password"
          classes={{ root: classes.input }}
          id="confirmPass-9"
          autoComplete="off"
          name="confirmPass"
          value={confirmPass}
          onChange={onChange}
          error={errors.confirmPass}
          helperText={errors.confirmPass}
        />
        <Button
          variant="contained"
          color="primary"
          classes={{ root: classes.button }}
          onClick={onClickVerify}
          disabled={
            !code || !pass || !confirmPass || errors.confirmPass || errors.code
          }
        >
          Verify & reset password
        </Button>
      </Grid>
    </Grid>
  );
};
